import React from 'react';
import { Star, Users } from 'lucide-react';
import { SectionHeader } from '../ui/Shared';
export function TestimonialsSection() {
  const testimonials = [{
    name: 'María G.',
    location: 'Bogotá',
    initials: 'MG',
    quote: 'Llevaba 3 años con omeprazol diario. A los 5 días del protocolo, dormí toda la noche sin despertarme. Mi gastroenterólogo no lo podía creer.',
    badge: 'Resultado en 5 días',
    colorClass: 'bg-accent/20 text-accent',
    borderColor: 'border-accent/30'
  }, {
    name: 'Roberto M.',
    location: 'Ciudad de México',
    initials: 'RM',
    quote: 'El ardor nocturno me tenía destruido. Probé la fórmula de hidratación y esa misma noche sentí la diferencia. Hoy llevo 2 meses sin una sola pastilla.',
    badge: 'Alivio la primera noche',
    colorClass: 'bg-success/20 text-success',
    borderColor: 'border-success/30'
  }, {
    name: 'Carmen L.',
    location: 'Buenos Aires',
    initials: 'CL',
    quote: 'Pensé que era otra estafa más. Pero a la semana ya no sentía la presión en el pecho ni el sabor amargo. Mi esposo dice que hasta dejé de roncar.',
    badge: 'Cambio en 7 días',
    colorClass: 'bg-[#805AD5]/20 text-[#805AD5]',
    borderColor: 'border-[#805AD5]/30'
  }];
  return <section id="testimonios" className="py-24 bg-surface" data-id="element-380">
      <div className="max-w-[1100px] mx-auto px-6" data-id="element-381">
        <SectionHeader tag="Prueba real" title={<>
              Lo que cambia en
              <br data-id="element-383" />
              <span className="text-accent" data-id="element-384">solo 7 días</span>
            </>} data-id="element-382" />

        <div className="stagger-children grid grid-cols-1 md:grid-cols-3 gap-6 mt-12" data-id="element-385">
          {testimonials.map((testimonial, idx) => <div key={idx} className="bg-secondary border border-white/10 rounded-2xl p-6 md:p-8 flex flex-col relative overflow-hidden transition-transform hover:-translate-y-1" data-id="element-386">
              <div className="flex items-center gap-4 mb-6" data-id="element-387">
                <div className={`w-12 h-12 rounded-full flex items-center justify-center font-bold text-lg ${testimonial.colorClass}`} data-id="element-388">
                  {testimonial.initials}
                </div>
                <div data-id="element-389">
                  <h4 className="text-text-light font-bold text-base" data-id="element-390">
                    {testimonial.name}
                  </h4>
                  <p className="text-text-muted text-sm" data-id="element-391">
                    {testimonial.location}
                  </p>
                </div>
              </div>

              <div className="flex gap-1 mb-4" data-id="element-392">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-current text-accent" data-id="element-393" />)}
              </div>

              <p className="text-text-muted text-[15px] leading-relaxed flex-1 italic mb-6" data-id="element-394">
                "{testimonial.quote}"
              </p>

              <div className={`inline-flex self-start items-center px-3 py-1 rounded-full text-xs font-semibold border ${testimonial.colorClass} ${testimonial.borderColor} bg-opacity-10`} data-id="element-395">
                {testimonial.badge}
              </div>
            </div>)}
        </div>

        <div className="scale-in mt-12 max-w-md mx-auto bg-accent/10 border border-accent/20 rounded-full py-3 px-6 flex items-center justify-center gap-3" data-id="element-396">
          <Users className="w-5 h-5 text-accent" data-id="element-397" />
          <span className="text-sm font-semibold text-text-light" data-id="element-398">
            +850 personas ya aplicaron el protocolo con éxito
          </span>
        </div>
      </div>
    </section>;
}